var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        ref: "formValidation",
        attrs: { slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ invalid }) {
              return [
                _c(
                  "form",
                  {
                    staticClass: "form-horizontal",
                    attrs: {
                      role: "form",
                      name: "integrationFrom",
                      novalidate: ""
                    }
                  },
                  [
                    _c(
                      "fieldset",
                      [
                        _vm.integration || _vm.currentIntegration.id
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("PLATFORM_NAME_LABEL"),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t("PLATFORM_NAME_TT")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "name",
                                          attrs: {
                                            rules: "required",
                                            slim: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .currentIntegration
                                                                      .name,
                                                                  expression:
                                                                    "currentIntegration.name"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                "data-testid":
                                                                  "integration-name",
                                                                type: "text",
                                                                placeholder: _vm.$t(
                                                                  "PLATFORM_NAME_PH"
                                                                ),
                                                                name: "name",
                                                                autocomplete:
                                                                  "off"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .currentIntegration
                                                                    .name
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  )
                                                                    return
                                                                  _vm.$set(
                                                                    _vm.currentIntegration,
                                                                    "name",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.integration && !_vm.newIntegration
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("PLATFORM_TYPE_LABEL"),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t("PLATFORM_TYPE_TT")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "type",
                                          attrs: { slim: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4 col-md-3"
                                                          },
                                                          [
                                                            _c(
                                                              "SearchableDropdown",
                                                              {
                                                                attrs: {
                                                                  "data-testid":
                                                                    "type-dropdown",
                                                                  config:
                                                                    _vm.integrationOptions
                                                                },
                                                                on: {
                                                                  change:
                                                                    _vm.onIntegrationTypeChange
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .currentIntegration
                                                                      .type,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.currentIntegration,
                                                                      "type",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "currentIntegration.type"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        (!_vm.integration || _vm.showOauthRegisterLoader) &&
                        !_vm.newIntegration
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("PLATFORM_AUTHORIZE_LABEL"),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t("PLATFORM_AUTHORIZE_TT")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "subId",
                                          attrs: { slim: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4"
                                                          },
                                                          [
                                                            !_vm.showOauthRegisterLoader &&
                                                            _vm
                                                              .currentIntegration
                                                              .type ==
                                                              "googleAds"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "clickable width-auto",
                                                                  attrs: {
                                                                    "data-testid":
                                                                      "google-auth-button",
                                                                    src: require("@/assets/images/btn_google_signin_light_normal_web.png")
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.authorize
                                                                  }
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            !_vm.showOauthRegisterLoader &&
                                                            _vm
                                                              .currentIntegration
                                                              .type !=
                                                              "googleAds"
                                                              ? _c("button", {
                                                                  directives: [
                                                                    {
                                                                      name: "t",
                                                                      rawName:
                                                                        "v-t",
                                                                      value:
                                                                        "PLATFORM_AUTHORIZE_BTN",
                                                                      expression:
                                                                        "'PLATFORM_AUTHORIZE_BTN'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "btn btn-success btn-sm",
                                                                  attrs: {
                                                                    "data-testid":
                                                                      "other-auth-button",
                                                                    type:
                                                                      "button"
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.authorize
                                                                  }
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.showOauthRegisterLoader
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "form-control-static m-b-4"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "Loader",
                                                                      {
                                                                        attrs: {
                                                                          "custom-class":
                                                                            "loader-container size-sm"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span", {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "t",
                                                                          rawName:
                                                                            "v-t",
                                                                          value:
                                                                            "REGISTERING",
                                                                          expression:
                                                                            "'REGISTERING'"
                                                                        }
                                                                      ]
                                                                    })
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentIntegration.type.toLowerCase() ==
                          "googleads" &&
                        (_vm.newIntegration ||
                          (_vm.integration &&
                            _vm.integration.status === "Pending"))
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("PLATFORM_ACCOUNT_LABEL"),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t("PLATFORM_ACCOUNT_TT")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "platformPrimaryId",
                                          attrs: {
                                            rules: "required",
                                            slim: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4"
                                                          },
                                                          [
                                                            _vm.loadingAccountsForUser
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "form-control-static m-b-4"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "Loader",
                                                                      {
                                                                        attrs: {
                                                                          "custom-class":
                                                                            "loader-container size-sm"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span", {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "t",
                                                                          rawName:
                                                                            "v-t",
                                                                          value:
                                                                            "LOADING_ACCOUNTS",
                                                                          expression:
                                                                            "'LOADING_ACCOUNTS'"
                                                                        }
                                                                      ]
                                                                    })
                                                                  ],
                                                                  1
                                                                )
                                                              : _c(
                                                                  "SearchableDropdown",
                                                                  {
                                                                    class: classes,
                                                                    attrs: {
                                                                      "data-testid":
                                                                        "account-dropdown",
                                                                      name:
                                                                        "platformPrimaryId",
                                                                      config:
                                                                        _vm.integrationAccountsOptions,
                                                                      rules:
                                                                        "required"
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.onAccountSelect
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .currentIntegration
                                                                          .platformPrimaryId,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.currentIntegration,
                                                                          "platformPrimaryId",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "currentIntegration.platformPrimaryId"
                                                                    }
                                                                  }
                                                                )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showSubAccounts
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("PLATFORM_SUB_MCC_ACCOUNT_LABEL"),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  "PLATFORM_SUB_MCC_ACCOUNT_TT"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "subAccountId",
                                          attrs: {
                                            rules: "required",
                                            slim: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4"
                                                          },
                                                          [
                                                            _vm.loadingSubAccountsForUser
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "form-control-static m-b-4"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "Loader",
                                                                      {
                                                                        attrs: {
                                                                          "custom-class":
                                                                            "loader-container size-sm"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span", {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "t",
                                                                          rawName:
                                                                            "v-t",
                                                                          value:
                                                                            "LOADING_SUB_ACCOUNTS",
                                                                          expression:
                                                                            "'LOADING_SUB_ACCOUNTS'"
                                                                        }
                                                                      ]
                                                                    })
                                                                  ],
                                                                  1
                                                                )
                                                              : _c(
                                                                  "SearchableDropdown",
                                                                  {
                                                                    attrs: {
                                                                      "data-testid":
                                                                        "sub-account-dropdown",
                                                                      name:
                                                                        "subAccountId",
                                                                      config:
                                                                        _vm.integrationSubAccountsOptions
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .currentIntegration
                                                                          .subAccountId,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.currentIntegration,
                                                                          "subAccountId",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "currentIntegration.subAccountId"
                                                                    }
                                                                  }
                                                                )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isFacebookIntegration &&
                        (_vm.newIntegration ||
                          (_vm.integration &&
                            _vm.integration.status === "Pending"))
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t(
                                  "PLATFORM_BUSINESS_MANAGER_LABEL"
                                ),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  "PLATFORM_BUSINESS_MANAGER_TT"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "platformPrimaryId",
                                          attrs: {
                                            rules: "required",
                                            slim: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4"
                                                          },
                                                          [
                                                            _vm.loadingFacebookDetailsForUser
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "form-control-static m-b-4"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "Loader",
                                                                      {
                                                                        attrs: {
                                                                          "custom-class":
                                                                            "loader-container size-sm"
                                                                        }
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span", {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "t",
                                                                          rawName:
                                                                            "v-t",
                                                                          value:
                                                                            "LOADING_BUSINESS_MANAGER_LIST",
                                                                          expression:
                                                                            "'LOADING_BUSINESS_MANAGER_LIST'"
                                                                        }
                                                                      ]
                                                                    })
                                                                  ],
                                                                  1
                                                                )
                                                              : _c(
                                                                  "SearchableDropdown",
                                                                  {
                                                                    attrs: {
                                                                      "data-testid":
                                                                        "business-manager-dropdown",
                                                                      name:
                                                                        "platformPrimaryId",
                                                                      config:
                                                                        _vm.integrationBusinessManagerOptions
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.onBusinessAccountSelect
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .currentIntegration
                                                                          .platformPrimaryId,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.currentIntegration,
                                                                          "platformPrimaryId",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "currentIntegration.platformPrimaryId"
                                                                    }
                                                                  }
                                                                )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showFbAdAccount
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("PLATFORM_AD_ACCOUNT_LABEL"),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t("PLATFORM_AD_ACCOUNT_TT")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "platformSubId",
                                          attrs: {
                                            rules: "required",
                                            slim: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4"
                                                          },
                                                          [
                                                            _c(
                                                              "SearchableDropdown",
                                                              {
                                                                attrs: {
                                                                  "data-testid":
                                                                    "fb-ad-accounts-dropdown",
                                                                  name:
                                                                    "platformSubId",
                                                                  config:
                                                                    _vm.integrationAdAccountsOptions
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .currentIntegration
                                                                      .platformSubId,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.currentIntegration,
                                                                      "platformSubId",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "currentIntegration.platformSubId"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-8 col-sm-offset-3" },
                            [
                              _vm.integration || _vm.newIntegration
                                ? _c(
                                    "PrimaryButton",
                                    {
                                      staticClass: "m-r-15",
                                      attrs: {
                                        "data-testid": "submit-button",
                                        size: "sm",
                                        type: "button",
                                        "show-loader-on-form": _vm.isUpdating,
                                        disabled:
                                          _vm.showOauthRegisterLoader ||
                                          _vm.loadingAccountsForUser ||
                                          invalid ||
                                          _vm.isUpdating
                                      },
                                      on: { click: _vm.onSave }
                                    },
                                    [
                                      _c("span", {
                                        directives: [
                                          {
                                            name: "t",
                                            rawName: "v-t",
                                            value: "UPDATE",
                                            expression: "'UPDATE'"
                                          }
                                        ]
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("button", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: "CANCEL",
                                    expression: "'CANCEL'"
                                  }
                                ],
                                staticClass: "btn btn-sm btn-danger",
                                attrs: {
                                  "data-testid": "cancel-button",
                                  type: "button",
                                  disabled:
                                    _vm.showOauthRegisterLoader ||
                                    _vm.loadingAccountsForUser ||
                                    _vm.isUpdating
                                },
                                on: { click: _vm.closeForm }
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }